import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DeliveryModal from './DeliveryModal/DeliveryModal';
import DamageCover from './DamageCover/DamageCover';

import content from 'assets/content/product.content.json';

import IcTruck from 'assets/images/general/ic-truck-free-delivery.svg';
import IcTool from 'assets/images/general/ic-tool.svg';
import info from 'assets/images/general/info.png';

import './DeliveryNInsurence.scss';

DeliveryNInsurence.propTypes = {
    productName: PropTypes.string,
    productSlug: PropTypes.string,
    isProductDA: PropTypes.bool
};

export default function DeliveryNInsurence({ productName, productSlug, isProductDA = false }) {
    const data = [
        {
            id: 1,
            icon: IcTruck,
            title: productSlug === 'samsung-galaxy-s25-edge' ? content?.CONTENT.DELIVERY_N_INSURE_TITLE1_PA_SLIM : content?.CONTENT.DELIVERY_N_INSURE_TITLE1,
            desc: productSlug === 'samsung-galaxy-s25-edge' ? content?.CONTENT.DELIVERY_N_INSURE_DESC1_PA_SLIM : content?.CONTENT.DELIVERY_N_INSURE_DESC1
        },
        {
            id: 2,
            icon: IcTool,
            title: content?.CONTENT.DELIVERY_N_INSURE_TITLE2 + (isProductDA ? ' (SC+ Included)' : ''),
            desc: content?.CONTENT.DELIVERY_N_INSURE_DESC2
        }
    ];

    const [isOpenForDeliveryModal, setIsOpenForDeliveryModal] = useState(false);
    const [isOpenForDamageCover, setIsOpenForDamageCover] = useState(false);

    const onToggle = (icon) => {
        if (icon === IcTruck) {
            setIsOpenForDeliveryModal(!isOpenForDeliveryModal);
        }

        if (icon === IcTool) {
            setIsOpenForDamageCover(!isOpenForDamageCover);
        }
    };

    return (
        <>
            <div className='deliveryNInsurence'>
                {data.map((item) => (
                    <div key={item.id} className='deliveryNInsurence__tile' onClick={() => onToggle(item.icon)}>
                        <img className='icon' src={item.icon} alt={item.title} />
                        <div className='w-100 content'>
                            <p className='content__title d-flex justify-content-between'>
                                <span>{item.title}</span>
                                <img className='icon' src={info} alt='info'/>
                            </p>
                            <p className='content__desc'>{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
            <DeliveryModal isOpen={isOpenForDeliveryModal} onToggle={() => onToggle(IcTruck)} productSlug={productSlug}
                isProductDA={isProductDA}/>
        </>
    );
}
